import React, { useContext } from 'react';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { useIntl } from 'react-intl';
import Cookies from "universal-cookie"
import { getCookieOptions } from '../../utils/utils'

const APP_NAME = 'id360'

const AdminLogout = ({ history }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const {
    setAuthToken,
    setCurrentUser
  } = useContext(RootContext);

  const getLogoutHref = () => {
    const location = window.location.pathname
    let path = location !== '/' ? location : ''
    path = path?.split('?')[0]
    return `${process.env.REACT_APP_IDCLOUD_HOST}/login?app=${APP_NAME}&path=${path}`
  }

  const logout = () => {
    setAuthToken(null);
    setCurrentUser(null);
    const cookies = new Cookies()
    let copts = getCookieOptions()
    cookies.remove('logged-in', { path: copts.path, domain: copts.domain })
    window.location.href = getLogoutHref()
  }

  return (
    <div>
      <button className="btn-clear" onClick={logout}>{t('ui.logout')}</button>
    </div>
  )
}

export default AdminLogout;